import { useInfiniteQuery } from '@tanstack/vue-query';
import axios from '@/app/api/axios.js';
import { transformFilters } from '@/shared/utils/transform-filters.js';
import { useTeamStore } from '#modules/team/stores/team.store.js';
import { useInvoicesStore } from '#modules/invoices/stores/invoices.store.js';
import { storeToRefs } from 'pinia';

export const useInvoices = () => {
    const invoicesStore = useInvoicesStore();
    const teamStore = useTeamStore();

    const { searchQuery } = storeToRefs(invoicesStore);

    return useInfiniteQuery({
        queryKey: ['invoices', teamStore.team.id, searchQuery],
        queryFn: async ({ pageParam = 1 }) => {
            const response = await axios.get('/general/invoices', {
                params: transformFilters({
                    page: pageParam,
                    per_page: 30,
                    team_id: teamStore.team.id,
                    search: searchQuery.value,
                }),
            });

            return response.data;
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage) => {
            const meta = lastPage.meta;

            if (!meta) {
                return undefined;
            }

            return meta.current_page < meta.last_page ? meta.current_page + 1 : undefined;
        },
        placeholderData: (previousData) => previousData,
        refetchOnWindowFocus: false,
        refetchOnMount: 'always',
    });
};
